import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { fontSourceSerif4, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { Swiper } from "scmp-app/components/swiper";

export const SectionTitle = styled.div`
  padding-block-end: 10px;

  color: rgba(0, 0, 0, 0.8);
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const StyledSwiper = styled(Swiper)`
  inline-size: 100%;

  touch-action: pan-y;

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  &.swiper-slide {
    inline-size: 153px;
  }

  ${theme.breakpoints.up("tablet")} {
    &.swiper-slide {
      inline-size: 125px;
    }
  }

  ${theme.breakpoints.up("desktop")} {
    &.swiper-slide {
      inline-size: 156px;
    }
  }
`;
